module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DE79_1SF_GKK.1eb4466a.png";